import { useDocumentTitle } from "@uidotdev/usehooks";

export const usePageTitle = (title: string) => {
  useDocumentTitle(`${title} | LevelsRx`);
};
